import moment from 'moment';

const formatDateApi = (date) => {
  if (date != null) {
    const year = date.getFullYear();
    const month = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
    const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
    return `${year}-${month}-${day} 00:00:00`;
  }
  return null;
};

const formatDateTimeApi = (datetime) => {
  if (datetime != null) {
    const year = datetime.getFullYear();
    const month = ((datetime.getMonth() + 1) < 10 ? '0' : '') + (datetime.getMonth() + 1);
    const day = (datetime.getDate() < 10 ? '0' : '') + datetime.getDate();
    const hours = (datetime.getHours() < 10 ? '0' : '') + datetime.getHours();
    const mins = (datetime.getMinutes() < 10 ? '0' : '') + datetime.getMinutes();
    const secs = (datetime.getSeconds() < 10 ? '0' : '') + datetime.getSeconds();
    return `${year}-${month}-${day} ${hours}:${mins}:${secs}`;
  }
  return null;
};

const ago = (dateStr) => {
  if (!dateStr) return 'New';
  const date = moment(new Date(`${dateStr} UTC`));
  if (moment().diff(date, 'days') >= 1) {
    return `Updated ${date.fromNow()}`; // '2 days ago' etc.
  }
  return `Updated ${date.calendar().split(' ')[0]}`; // 'Today', 'yesterday', 'tomorrow'
};

const formatDate = (date, format = 'D MMM YYYY') => {
  if (date) {
    return moment(new Date(`${date} UTC`)).format(format);
  }
  return '';
};

const formatDateNormal = (date, format = 'D MMM YYYY') => {
  if (date) {
    return moment(new Date(`${date}`)).format(format);
  }
  return '';
};

const convertToUTC = (date, format = 'D MMM YYYY') => {
  if (date) {
    return moment.utc(new Date(`${date}`)).format(format);
  }
  return '';
};

const convertFromUTC = (date, format = 'D MMM YYYY') => {
  if (date) {
    return moment(new Date(`${date}Z`)).format(format);
  }
  return '';
};

const getDateUTC = date => new Date(`${date} UTC`);

const isValidDate = (date) => {
  try {
    if (!date || date.length === 0) {
      return false;
    }
    return moment(new Date(date)).isValid();
  } catch (e) {
    return false;
  }
};

/**
 * Gets duration difference since a date.
 * Dates get compared as midnight.
 *
 * @param {string} anotherDate ISO-8601 date string (i.e.: ensure UTC dates have a "Z" at the end)
 * @param {string} timeframe moment.js time frame (e.g.: "months", "days", "weeks", "hours", "minutes")
 * @return {number|null} duration difference. The returned number is positive if "anotherDate" is in future, & vice versa.
 */
const getDurationDiff = (anotherDate, timeframe) => {
  if (!anotherDate) {
    console.warn('Failed to get date diff');
    return null;
  }

  const momentAnotherDate = moment(anotherDate).startOf('day');
  const momentToday = moment().startOf('day');
  return momentAnotherDate.diff(momentToday, timeframe);
};

/**
 * Gets duration difference since a date (as a descriptive label).
 *
 * @param {string} anotherDate ISO-8601 date string (i.e.: ensure UTC dates have a "Z" at the end)
 * @param {string} timeframe moment.js time frame (e.g.: "months", "days", "weeks", "hours", "minutes")
 * @return {string|null} duration difference as a descriptive label
 */
const getDurationDiffLabel = (anotherDate, timeframe) => {
  const diff = getDurationDiff(anotherDate, timeframe);
  if (diff === null || diff === undefined) {
    console.warn('Failed to get date diff label');
    return null;
  }

  let label = null;
  const diffAbs = Math.abs(diff);
  if (diff === 1) {
    label = 'tomorrow';
  } else if (diff === -1) {
    label = 'yesterday';
  } else if (diff > 0) {
    label = `in ${diffAbs} ${timeframe}`;
  } else if (diff < 0) {
    label = `${diffAbs} ${timeframe} ago`;
  } else if (diff === 0) {
    label = 'today';
  }
  return label;
};


/**
 * Gets duration difference since a date.
 * Dates get compared as midnight.
 *
 * @param {string} anotherDate ISO-8601 date string (i.e.: ensure UTC dates have a "Z" at the end)
 * @param {string} timeframe moment.js time frame (e.g.: "months", "days", "weeks", "hours", "minutes")
 * @return {number|null} duration difference. The returned number is positive if "anotherDate" is in future, & vice versa.
 */
const getPastDateDiff = (anotherDate, timeframe) => {
  if (!anotherDate) {
    console.warn('Failed to get date diff');
    return null;
  }
  const momentAnotherDate = moment(anotherDate).startOf('month');
  const momentToday = moment().startOf('month');
  return momentAnotherDate.diff(momentToday, timeframe);
};

const getPreviousDate = (dateFrom, timeDiff, timeUnit, format = 'D MMM YYYY') => {
  if (!dateFrom) {
    console.warn('dateFrom cannot be null');
    return null;
  }

  if (!Number.isInteger(timeDiff)) {
    console.warn('invalid timeDiff type');
    return null;
  }
  const previousDate = moment(dateFrom).subtract(timeDiff, timeUnit).format(format);
  return previousDate;
}


const isSameOrAfter = (dateFrom, dateTo, timeUnit) => {
  if (!dateFrom || !dateTo) {
    console.warn('dateFrom or dateTo cannot be null');
    return null;
  }
  return moment(dateFrom).isSameOrAfter(moment(dateTo), timeUnit); 
}

export default {
  formatDateApi,
  formatDateTimeApi,
  formatDate,
  ago,
  convertToUTC,
  convertFromUTC,
  getDateUTC,
  isValidDate,
  formatDateNormal,
  getDurationDiff,
  getDurationDiffLabel,
  getPreviousDate,
  getPastDateDiff,
  isSameOrAfter,
};
